import './styles';
import { Game } from './game';

const canvas = document.getElementById('game-canvas') as HTMLCanvasElement;

if (!canvas) {
  throw new Error('Canvas element not found');
}

const game = new Game(canvas);

// Cleanup on page unload
window.addEventListener('beforeunload', () => {
  game.dispose();
});
